import { HTTP_STATUS_CODE } from '@payments-checkout/shared/helpers/constants/http-status.const';
import { useHandleRedirectByError } from '@payments-checkout/shared/helpers/hooks/useHandleRedirectByError';
import { JadeProvider } from '@stone-payments/jade';
import { JadeTheme } from '@stone-payments/jade/dist/esm/hooks/use-jade-provider';
import type { AxiosError } from 'axios';
import { notFound, useParams } from 'next/navigation';
import { getThemeProvider } from '../../app/helpers/getThemeProvider';
import { LoadingState } from '../../components/loading';
import { usePaymentLinkId } from '../../hooks/usePaymentLinkId';

export const JadeProviderSecondaryColor = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const params = useParams<{ paymentLinkId: string }>();
  const {
    data: paymentLinkData,
    isLoading,
    error,
    isError,
  } = usePaymentLinkId(params.paymentLinkId);
  const { redirectByCode } = useHandleRedirectByError();

  if (isLoading) {
    return <LoadingState fullPage />;
  }

  if (error || isError) {
    const status = (error as AxiosError)?.response?.status;

    if (status === HTTP_STATUS_CODE.NOT_FOUND) {
      return notFound();
    }

    redirectByCode(status);
    return <LoadingState fullPage />;
  }

  const customTheme = paymentLinkData?.layout_settings?.secondary_color;
  const organization = paymentLinkData?.account_settings?.organization;
  const theme = getThemeProvider({ organization, customTheme });

  return <JadeProvider theme={theme as JadeTheme}>{children}</JadeProvider>;
};
